import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		MenuButton
	} from '@headlessui/vue'

	import VButton from '@/components/Buttons/VButton.vue'

	import {
		inject
	} from "vue"
	
	
	const __default__ = { name: 'VDropdownButton' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		as: {
			type: Object,
			default: VButton
		}
	},
  setup(__props) {

const props = __props;

	

	const menuId: string = inject('menuId', null) || ""

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MenuButton), {
    as: __props.as,
    id: _unref(menuId)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "id"]))
}
}

})